export const environment = {
  production: false,
  register_per_page: 10,
   api_url: 'https://inap-hrm-back.sigei.gob.do/api',
  api_lobby: 'https://lobby.sigei.gob.do/api',
  api_doc: 'https://xdms-inap.azurewebsites.net/api',
  lobbyUrl: 'https://sigei.gob.do/',
  copyright_footer: `Copyright © Instituto Tecnológico de las Américas 2023`,
};
